import React from 'react'
import { Box, Flex, Skeleton, Stack, Text } from '@chakra-ui/react'
import Header from '../../../Header'
import { LoadingStateProps } from '../types'

const LoadingState: React.FC<LoadingStateProps> = ({ title, subtitle }) => (
  <Box p={{ base: 2, md: 4 }}>
    <Header title={title} subtitle={subtitle} />
    
    <Flex 
      direction="column" 
      bg="gray.800" 
      borderRadius="lg" 
      boxShadow="lg" 
      p={4} 
      mb={4}
    >
      <Flex align="center" mb={4}>
        <Skeleton height="50px" width="50px" borderRadius="full" mr={4} />
        <Stack flex={1}>
          <Skeleton height="24px" width="200px" />
          <Skeleton height="16px" width="150px" />
        </Stack>
        <Skeleton height="60px" width="120px" />
      </Flex>
      
      <Skeleton height="300px" mb={4} />
      
      <Flex wrap="wrap" gap={4}>
        <Skeleton height="100px" width={{ base: "100%", md: "calc(50% - 8px)", lg: "calc(25% - 12px)" }} />
        <Skeleton height="100px" width={{ base: "100%", md: "calc(50% - 8px)", lg: "calc(25% - 12px)" }} />
        <Skeleton height="100px" width={{ base: "100%", md: "calc(50% - 8px)", lg: "calc(25% - 12px)" }} />
        <Skeleton height="100px" width={{ base: "100%", md: "calc(50% - 8px)", lg: "calc(25% - 12px)" }} />
      </Flex>
    </Flex>
    
    <Text textAlign="center" fontSize="sm" color="gray.500" mt={8}>
      Loading stock data...
    </Text>
  </Box>
)

export default LoadingState
